import { isPlainObject, isString } from '@flowio/is';
export function isApplePayWindowMessage(event, channelId) {
  return isString(event.data) && event.data.substring(0, channelId.length + 1) === "".concat(channelId, " ");
}
export function isApplePayWindowMessageType(value) {
  var validTypes = ['APPLE_PAY_WINDOW_READY_MESSAGE', 'APPLE_PAY_PAYMENT_RESULT_MESSAGE', 'APPLE_PAY_WINDOW_PARAMETERS_MESSAGE'];
  return isPlainObject(value) && 'type' in value && validTypes.includes(value.type);
}
export function parseApplePayWindowMessage(event, channelId) {
  if (!isApplePayWindowMessage(event, channelId)) {
    // this message is not for us it seems.
    return null;
  }

  try {
    var messageJson = event.data.substr(channelId.length + 1);
    var parseMessage = JSON.parse(messageJson);

    if (isApplePayWindowMessageType(parseMessage)) {
      return parseMessage;
    }
  } catch (e) {// noop
  }

  return null;
}
export function isMatchingOrigin(event, origin) {
  return event.origin === origin;
}
//# sourceMappingURL=utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/payment_methods/applepay/utilities.js
// module id = 311
// module chunks = 0 1